import { render } from "./MyHeaderRightPart.vue?vue&type=template&id=d3b70436&scoped=true"
import script from "./MyHeaderRightPart.vue?vue&type=script&lang=js"
export * from "./MyHeaderRightPart.vue?vue&type=script&lang=js"

import "./MyHeaderRightPart.vue?vue&type=style&index=0&id=d3b70436&scoped=true&lang=css"

import exportComponent from "C:\\projects\\frontend\\inso-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3b70436"]])

export default __exports__